import { Tooltip } from "@xola/ui-kit";
import React, { ReactElement, ReactNode } from "react";
import { NoTranslate } from "../../Common/NoTranslate";

interface BlackoutTimeslotTooltipProps {
    reason?: string;
    heading?: ReactNode;
    children: ReactElement;
}

export const BlackoutTimeslotTooltip = ({ reason, heading, children }: BlackoutTimeslotTooltipProps) => {
    if (!reason) {
        return children;
    }

    return (
        <Tooltip
            followCursor
            placement="top"
            className="block h-full w-full"
            content={
                <NoTranslate>
                    {heading}
                    <span className="block whitespace-pre-line">{reason}</span>
                </NoTranslate>
            }
        >
            {children}
        </Tooltip>
    );
};
